//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import manba from 'manba'
import { mapGetters } from 'vuex'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import StockKittingTools from '../StockTools/StockKittingTools.vue'
import StockKittingToolsForm from '../StockTools/StockKittingToolsForm.vue'
import { EventBus } from '../../EventBus/EventBus.js'
import Comment from '../../components/Comments/Comment.vue'
import { filterFn, createFieldConfig, Store } from '../../components/QSelectUtils.js'
import { convertTime } from '../../components/helpers.js'
import SkockKittingDatailedDebitsBanner from '../StockTools/SkockKittingDatailedDebitsBanner.vue'
import StockKittingStateHistory from '../StockTools/StockKittingStateHistory.vue'
import ItemsSearchField from '../../components/Field/ItemsSearchField.vue'

const SDP_KEY = '869c1dec-750d-4c0e-a13c-052dae6d78f3'

class StockKittingManager {
  constructor (config) {
    this.request = this.request || null
    // this.allowedStockSourcesIds = config.allowedStockSourcesIds || null
    this.allowedToolsIds = config.allowedToolsIds || null
  }

  get state () {
    return (this.request && this.request.stateData && this.request.stateData.state) || null
  }

  get isDogovor () {
    return this.request && this.request.stockType == 'dogovor'
  }

  get isDetailedDebits () {
    return this.request && this.request.stock && this.request.stock.detailedDebits
  }

  get isDogovorWithDetailedDebits () {
    return this.isDogovor && this.isDetailedDebits
  }

  get project () {
    return /* this.isDogovorWithDetailedDebits && */ this.request && this.request.project || null
  }

  get serviceObject () {
    return this.isDogovorWithDetailedDebits && this.request && this.request.serviceObject || null
  }

  get targetStockId () {
    if (this.isDogovor) {
      return this.request && this.request.stock && this.request.stock.id
    }
    return null
  }

  get allowedStockSourcesIds () {
    if (this.isDogovor) {
      const stock = this.request && this.request.stock || null
      return stock && stock.stockSources || null
    }
    return null
  }

  get toolRecordsValid () {
    const toolsRecords = this.request && this.request.tools || []
    if (toolsRecords.length === 0) {
      return false
    }
    for (const record of toolsRecords) {
      if (this.isStockNotAllowed(record) || this.isToolNotAllowed(record) || this.isToolAmountExceeded(record) && !this.ignoreLimits) {
        return false
      }
    }
    return true
  }

  get ignoreLimits () {
    const stock = this.request && this.request.stock || null
    return stock && stock.ignoreLimits && this.isDetailedDebits || false
  }

  // ===

  isStockNotAllowed (record) {
    return !!(this.isDetailedDebits && this.state !== 'SK5' && this.isDogovor && record.stock && this.allowedStockSourcesIds && !this.allowedStockSourcesIds.includes(record.stock.id))
  }

  isToolNotAllowed (record) {
    return !!(this.isDetailedDebits && this.state !== 'SK5' && this.isDogovor && record.tool && this.allowedToolsIds && !this.allowedToolsIds.includes(record.tool.id))
  }

  isToolAmountExceeded (record) {
    return !!(this.state !== 'SK5' && record.amount != null && record.amountStock != null && record.amount > record.amountFree)
  }
}

function formatInitials (name) {
  if (!name) {
    return ''
  }
  const arrFullName = name.split(' ')
  return arrFullName[0] + ' ' +
             (arrFullName[1] ? (arrFullName[1].substring(0, 1) + '.') : '') + ' ' +
             (arrFullName[2] ? (arrFullName[2].substring(0, 1) + '.') : '')
}

export default {
  components: {
    ItemsSearchField,
    StockKittingTools,
    StockKittingToolsForm,
    // Comments,
    Comment: Comment,
    SkockKittingDatailedDebitsBanner,
    StockKittingStateHistory
  },
  props: {
    isTransfer: {
      type: Boolean,
      default: false
    },
    isApplicant: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const vm = this

    return {
      manager: new StockKittingManager({}),

      newRecord: true,
      requestComment1C: null,
      model: {},
      loading: false,
      formKitting: false,
      stockTypes: [ // TODO получать с сервера StockEntity.StockType
        { key: 'auto', name: 'Автомобиль' },
        { key: 'box', name: 'Ящик' },
        { key: 'brigade', name: 'Бригада' },
        { key: 'stationary', name: 'Стационарный' },
        { key: 'common', name: 'Общий' },
        { key: 'dogovor', name: 'Договор' }
      ],
      thumbStyle: {
        right: '4px',
        borderRadius: '5px',
        background: '#A9A9A9',
        width: '10px',
        opacity: 1
      },
      modelTool: null,
      testTime: { stock: 0, brigade: 0 },
      canUpdateFilter: { stock: true, brigade: true, sourceBrigade: true },
      objectId: null,
      canAddComments: false,
      validKittingTime: false,
      reasonCansel: '',
      hoverReady: false,

      applicantFieldConfig: createFieldConfig({
        allRecordsFn: this.getApplicants,
        cached: true,
        storeType: 'server'
      }),
      organizationFieldConfig: createFieldConfig({ allRecordsFn: this.getOrganizations }),
      stockTypesFieldConfig: createFieldConfig({ allRecordsFn: () => Promise.resolve(this.stockTypes) }),
      projectFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getProjects,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 0
      })),
      brigadeFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getBrigadesFiltered,
        cached: false,
        storeType: 'server',
        fullReadable: true,
        searchable: true,
        searchFiltrationBySource: false,
        searchValueMinLength: 0
      })),
      stockFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getStocks,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 0
      })),
      sourceBrigadeFieldConfig: createFieldConfig(this.getSourceBrigadesFiltered),

      serviceObjectFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: false,
        cached: true,
        proxy: {
          urlBase: '/service/delta/serviceobject/search',
          get urlParams () {
            const params = {}
            if (vm.model && vm.model.project) {
              params.project = vm.model.project.id
            }
            return params
          },
          filterType: 'serviceObject',
          formId: 'stockKittingServiceObject'
        }
      })),
      serviceObjectTableColumns: [
        {
          name: 'alias',
          label: 'Название',
          align: 'left',
          defaultWidth: 130,
          field: 'alias',
          sortable: true
        },
        {
          name: 'fvfComplexNumber',
          label: 'Номер комплекса',
          labelTable: 'Номер</br>комплекса',
          align: 'left',
          defaultWidth: 80,
          field: 'fvfComplexNumber',
          sortable: true
        },
        {
          name: 'typeAlias',
          label: 'Тип',
          align: 'left',
          defaultWidth: 40,
          field: 'typeAlias',
          sortable: true
        },
        {
          name: 'address',
          label: 'Адрес',
          align: 'left',
          defaultWidth: 600,
          field: 'address',
          sortable: true
        }
      ],

      idDisabledBrigade: false,
      consistBrigadeStocks: [],
      isActiveTools: this.newRecord
    }
  },
  computed: {
    ...mapGetters({
      workShifts: 'getWorkShifts',
      user: 'getUser'
    }),
    type: function () {
      return this.isTransfer ? 'stockKittingTransferRequest' : 'stockKittingRequest'
    },
    updateEvent: function () {
      return 'update-' + this.type
    },
    state () {
      return (this.model && this.model.stateData && this.model.stateData.state) || null
    },
    showSaveBtn  () { /* SK1 || SK2 */
      const isValidTools = this.model &&
                           ((this.model.actionsAccess && (this.model.actionsAccess.SK1 || this.model.actionsAccess.SK2)) || this.newRecord)
      return isValidTools
    },
    editable () {
      return this.showSaveBtn && !!this.model.organization
    },
    editableMaterials () {
      return this.editable && this.projectValid && !!this.model.stockType && !!this.model.stock
    },
    isValidStockSave () {
      return this.isTransfer ? (!!this.model.brigade) : this.editable
    },
    isActiveSave () {
      return this.manager.toolRecordsValid && (this.isTransfer ? (this.model.brigade && this.model.sourceBrigade) : !!this.model.organization && this.projectValid && !!this.model.stock && !!this.model.stockType && !!this.model.applicant)
    },
    isValidReady  () { /* SK3 */
      const isValidR = this.model && this.model.actionsAccess && this.model.actionsAccess.SK3
      /* this.model.stateData && ['SK1', 'SK2', 'SK6', 'SK7', 'SK8'].includes(this.model.stateData.state) */
      return isValidR
    },
    isActiveReady  () {
      return this.manager.toolRecordsValid && (!!this.model.stock && !!this.model.applicant) && this.projectValid && this.serviceObjectValid
    },
    showReadyBtnDisabledInfo: function () {
      return this.isValidReady && (
        !this.model.stock ||
        (!this.model.applicant && !this.isTransfer) ||
        (this.isTransfer && (!this.model.sourceBrigade || !this.model.brigade)) ||
        !this.projectValid ||
        !this.serviceObjectValid
      )
    },
    isValidCansel  () { /* SK7 */
      const isValidC = this.model && !this.newRecord &&
        this.model.actionsAccess && this.model.actionsAccess.SK7
      // !['SK7', 'SK5'].includes(this.model.stateData.state)
      return isValidC
    },
    isValidReject  () { /* SK6 */
      const isValidC = this.model &&
        this.model.actionsAccess && this.model.actionsAccess.SK6
      // ['SK3', 'SK4'].includes(this.model.stateData.state)
      return isValidC
    },
    isValidAgree  () { /* SK4 */
      const isValidC = this.model &&
        this.model.actionsAccess && this.model.actionsAccess.SK4
      // ['SK3'].includes(this.model.stateData.state)
      return isValidC
    },
    isActiveAgree () { /* SK4 */
      return this.manager.toolRecordsValid
    },
    isMobileDevice: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    currentStateHistoryItem: function () {
      if (this.model && this.model.stateHistory && this.model.stateHistory.length) {
        return this.model.stateHistory[this.model.stateHistory.length - 1]
      }
      return null
    },
    applicantFieldReadonly: function () {
      if (this.isTransfer || !this.editable) {
        return true
      }
      return this.user.isContractor
    },
    organizationFieldActive: function () {
      return true
    },
    organizationFieldReadonly: function () {
      return !this.showSaveBtn
    },
    projectRequired: function () {
      return this.manager.isDogovor && !this.organizationSDP
    },
    projectValid: function () {
      return !this.projectRequired || !!this.model.project
    },
    projectFieldActive: function () {
      return this.model && (!this.model.stock ? this.model.stockType == null || this.manager.isDogovor : this.manager.isDogovor)
    },
    projectFieldReadonly: function () {
      return !this.editable || this.organizationSDP
    },
    organizationSDP: function () {
      if (this.model.organization && this.model.organization.key) {
        return this.model.organization.key === SDP_KEY
      }
      return false
    },
    serviceObjectRequired: function () {
      return this.manager.isDogovorWithDetailedDebits
    },
    serviceObjectValid: function () {
      return !this.serviceObjectRequired || !!this.model.serviceObject
    },
    serviceObjectFieldActive: function () {
      return this.serviceObjectRequired || !!this.model.serviceObject
    },
    showDetailedDebitsBanner: function () {
      return this.manager.isDogovorWithDetailedDebits && this.model.project
    }
  },
  watch: {
    $route: {
      handler: function (router) {
        if (router.params.id) {
          this.onOpen(router.params.id)
          // this.$router.push(this.$route.path.split('/' + params.id)[0] + (this.isTransfer ? 'Transfer' : '')).catch(() => { })
        }
      },
      immediate: true
    },
    formKitting: function (state) {
      if (!state) {
        this.close()
      }
    },
    user: {
      handler: function (user) {
        if (user && user.roles) {
          this.idDisabledBrigade = !user.fullAccess && !user.hasRole('dispatcher')
        }
      },
      deep: true,
      immediate: true
    },
    'model.tools': function (tools) {
      this.isActiveTools = !!((tools && tools.length))
    },
    'model.organization.id': function () {
      // Сбрасываем список предложенных заявителей, т.к. зависит от выбранной организации
      this.applicantFieldConfig.reset()
    },
    'manager.isDogovorWithDetailedDebits': function (value) {
      if (!value) {
        if (this.model && this.model.serviceObject) {
          this.model.serviceObject = null
        }
      }
      this.updateFields()
    }
  },
  methods: {
    convertTime: convertTime,
    updateFields: function () {
      this.$nextTick(() => {
        if (this.isTransfer && this.$refs.selectSourceBrigade) {
          this.$refs.selectSourceBrigade.updateInputValue(this.model.sourceBrigade ? this.model.sourceBrigade.name : '', false)
        }
        if (this.$refs.selectProject) {
          this.$refs.selectProject.hardResetValidation()
        }
        if (this.$refs.selectServiceObject) {
          this.$refs.selectServiceObject.hardResetValidation()
        }
      })
    },
    onOpen: async function (id = null) {
      this.validKittingTime = false
      this.objectId = id
      this.formKitting = true
      this.consistBrigadeStocks = []
      if (id !== null) {
        this.newRecord = false
        this.model = await this.getStockKitting(id)
        this.manager.request = this.model

        this.updateAllowedToolsIds()
      } else {
        this.newRecord = true
        this.model = this.getEmptyStockKitting()
        if (this.isMobileDevice && this.model.brigade) {
          this.getStocks().then(arr => {
            this.consistBrigadeStocks = arr
            this.setStock(arr[0] || null)
            this.updateFields()
          })
        }

        this.manager.request = this.model
        this.requestComment1C = null
        this.canAddComments = false
      }
      this.updateFields()
    },
    parseDate (value) {
      const pattern = /(\d{2})-(\d{2})-(\d{4})\s(\d{2}):(\d{2})/
      return new Date(value.replace(pattern, '$3-$2-$1T$4:$5'))
    },
    onShiftSelected: function (kittingShiftKey) {
      const kittingShift = this.workShifts.find(workShift => workShift.key === kittingShiftKey)

      let workTime = ''
      const kittingTime = this.parseDate(this.model.kittingTime)

      if (kittingShift) {
        workTime = kittingShift.startHour + ':00'
      } else {
        workTime = manba(kittingTime.getTime()).format('HH:mm')
      }

      const testTime = manba(kittingTime.getTime()).format('DD-MM-YYYY ') + workTime
      this.setKittingTime(testTime, kittingShift)
    },
    testCurrentKittingTime: function () {
      this.validKittingTime = this.testKittingTime(this.model.kittingTime)
      return this.validKittingTime
    },
    testKittingTime: function (kittingTime) {
      const now = new Date()
      if (now.getTime() > this.parseDate(kittingTime).getTime()) {
        this.$d_ask(() => {
          const newKittingTime = manba(now.getTime()).add(1, manba.HOUR).format('DD-MM-YYYY HH:mm')
          this.setKittingTime(newKittingTime, null, true)
        }, 'Внимание!', null, {
          yes: 'Исправить автоматически',
          cancel: 'Исправить вручную'
        }, ['Требуемое время комплектации \n не может быть меньше \n текущего времени!'])

        return false
      }
      return true
    },
    onKittingTimeSelected: function (kittingTime) {
      this.setKittingTime(kittingTime)
    },
    setKittingTime: function (kittingTime, kittingShift = null, valid) {
      if (!!valid || this.testKittingTime(kittingTime)) {
        this.model.kittingTime = kittingTime
        this.model.kittingShift = kittingShift
        this.validKittingTime = true

        this.$refs.ChangeTKittingTime.hide()
        this.$refs.ChangeDKittingTime.hide()

        this.brigadeFieldConfig.reset()
      }
    },
    setBrigade: function (val) {
      const t = this
      if (!(val === null)) {
        this.model.brigade = { id: val.id, name: val.name, key: val.key, type: val.type }
        if (!this.isTransfer) {
          this.getBrigadeConfiguration(val).then(configuration => {
            if (configuration.defaultApplicant) {
              this.setApplicant(configuration.defaultApplicant)
            }
            // else {
            //   const brigadier = val.employees && val.employees.find(employee => employee.brigadier) || null
            //   if (brigadier) {
            //     this.setApplicant({ id: brigadier.id, name: brigadier.fio })
            //   }
            // }
          })
        }
        this.getBrigadeStocks(val.id).then(function (arr) {
          t.consistBrigadeStocks = arr
          t.setStock(arr[0] ? arr[0] : null)
          // t.updateFields()
        })
      } else {
        if (this.isTransfer && this.model.stock) {
          this.setStock(null)
        }
        this.model.brigade = null
        this.canUpdateFilter.brigade = true
        this.consistBrigadeStocks = []
      }
      this.updateFields()
    },
    filterFnSourceBrigade: function (val, update, abort) {
      return filterFn(val, update, abort, this.sourceBrigadeFieldConfig)
    },
    setSourceBrigade: function (val) {
      this.$refs.selectSourceBrigade.resetValidation()
      if (!(val === null)) {
        const brigadier = val.employees ? val.employees.filter(function (el) {
          return el.brigadier
        }) : null
        this.model.sourceBrigade = { id: val.id, name: val.name, key: val.key, type: val.type }
        if (brigadier) {
          this.setApplicant({ id: brigadier[0].id, name: brigadier[0].fio })
        }
        // this.model.applicant = { id: brigadier[0].id, name: brigadier[0].fio }
      } else {
        this.model.sourceBrigade = null
        this.model.applicant = null
        this.canUpdateFilter.sourceBrigade = true
      }
      this.cancelField('selectSourceBrigade')
    },
    getStocksFromTools: function () {
      return (this.model && this.model.tools)
        ? this.model.tools.map(a => ({ ...a })).filter(function (b) {
          return b.stock.id
        }).map(function (c) {
          return c.stock.id
        })
        : null
    },
    getSourceBrigadesFiltered: function () {
      const isTransfer = this.isTransfer
      const brigade = this.model.brigade
      const arrBrigades = this.getBrigades().then(function (response) {
        if (response && Array.isArray(response)) {
          return (isTransfer && brigade) ? response.map(a => ({ ...a })).filter(function (b) {
            return b.id !== brigade.id
          }) : response
        } else {
          return []
        }
      })
      return arrBrigades
    },
    getBrigadesFiltered: function () {
      const isTransfer = this.isTransfer
      const sourceBrigade = this.model.sourceBrigade
      const arrBrigades = this.getBrigades().then(function (response) {
        if (response && Array.isArray(response)) {
          return (isTransfer && sourceBrigade) ? response.map(a => ({ ...a })).filter(function (b) {
            return b.id !== sourceBrigade.id
          }) : response
        } else {
          return []
        }
      })
      return arrBrigades
    },
    getBrigades: function () {
      const urlParams = new URLSearchParams()

      if (this.model.kittingTime) {
        const kittingDate = this.parseDate(this.model.kittingTime).getTime()
        urlParams.set('workDate', kittingDate)
      }
      if (this.model.kittingShift) {
        urlParams.set('workShift', this.model.kittingShift)
      }
      if (!this.isTransfer && this.model.stock && this.model.stockType == 'brigade') {
        urlParams.set('stock', this.model.stock.id)
      }
      if (!this.isTransfer && this.model.organization) {
        urlParams.set('organization', this.model.organization.id)
      }
      const fields = ['employees', 'workShift', 'workDate'] // workShiftsEmployees, 'guiName'
      urlParams.set('fields', fields.join(','))

      return axiosGet({
        url: '/service/delta/brigade/lightsearch?' + urlParams.toString(),
        onSuccess: (response) => response.data,
        onFailure: (response) => {
          const errorMessage = 'Ошибка загрузки списка доступных бригад'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        },
        msgTarget: this
      })
    },
    getStocks: function (text = '') {
      const isTransfer = this.isTransfer
      const stockTools = !isTransfer ? this.getStocksFromTools() : null

      const urlParams = new URLSearchParams()
      urlParams.set('name', text)
      urlParams.set('searchTarget', true)
      urlParams.set('showDisabled', false)
      urlParams.set('stationaryMain', false)
      if (this.model.stockType) {
        urlParams.set('type', this.model.stockType)
      }
      if (this.model.brigade /* || isTransfer  ЗАЧЕМ так было ??? */) {
        urlParams.set('brigadeId', this.model.brigade.id)
      }
      if (this.model.organization) {
        urlParams.set('organization', this.model.organization.id)
      }
      if (this.model.project) {
        urlParams.set('project', this.model.project.id)
      }
      return axiosGet({
        url: '/service/delta/stock/kitting/request/searchStocks?' + urlParams.toString(),
        onSuccess: (response) => {
          const stockTypes = new Set(this.stockTypes.map(type => type.key))
          return response.data
            .filter(stockServiceObject => {
              /* let e = true
              if (!this.isTransfer && stockServiceObject.stockType === 'stationary' &&
                ['База Бережковская', 'Хозяйственный', 'Склад Материалы заказчика'].includes(stockServiceObject.stockName)) {
                e = false
              } */
              return stockTypes.has(stockServiceObject.stockType) && (!isTransfer ? (stockTools ? !stockTools.includes(stockServiceObject.stockId) : true) : true)
            })
            .map(stockServiceObject => this.parseStockServiceObject(stockServiceObject))
        },
        onFailure: (response) => {
          const errorMessage = 'Ошибка загрузки списка складов'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        }
      })
    },
    parseStockServiceObject: function (stockServiceObject) {
      return {
        id: stockServiceObject.stockId,
        name: stockServiceObject.stockName + (stockServiceObject.gosNumber ? (' ' + stockServiceObject.gosNumber) : ''),
        key: stockServiceObject.stockKey,
        type: stockServiceObject.stockType,
        typeName: this.getStockTypeName(stockServiceObject.stockType),
        gosNumber: stockServiceObject.gosNumber,
        project: stockServiceObject.project,
        detailedDebits: stockServiceObject.detailedDebits,
        stockSources: stockServiceObject.stockSources,
        ignoreLimits: !!stockServiceObject.ignoreLimits,
        nameShort: stockServiceObject.stockName
      }
    },
    getStockTypeName: function (key) {
      const stockType = this.stockTypes.find(stockType => stockType.key === key)
      return stockType ? stockType.name : '(тип не определен)'
    },
    setStock: function (val, ignoreProject) {
      if (val) {
        this.model.gosNumber = val.gosNumber
        this.model.stock = {
          id: val.id,
          name: val.nameShort || val.name,
          stockKey: val.key,
          stockType: val.type,
          gosNumber: val.gosNumber,
          detailedDebits: val.detailedDebits,
          stockSources: val.stockSources,
          ignoreLimits: !!val.ignoreLimits
        }
        this.model.stockType = val.type

        if (!ignoreProject) {
          this.model.project = val.project || null
        }
      } else {
        this.model.stock = null
        this.model.gosNumber = null
        this.model.vehicle = null
        // if (!ignoreProject) {
        //   this.model.project = null
        // }
        this.canUpdateFilter.stock = true
      }

      this.updateAllowedToolsIds()
    },
    setStockType: function (stockType) {
      this.model.stockType = stockType && stockType.key || null

      if (stockType !== 'dogovor' && this.model.project) {
        this.model.project = null
      }

      this.setStock(null)
    },
    getFormData: function (id) {
      this.loading = true
      return axiosGet({
        url: '/service/delta/stock/kitting/request/formData?id=' + id,
        onSuccess: (response) => {
          this.model.kittingShift = []
          this.model.stockType = []
          response.data.forEach(element => {
            this.model.kittingShift.push(element.kittingShift)
            this.model.stockType.push(element.stockType)
          })
        },
        onFailure: (response) => {
          const errorMessage = 'Ошибка получения дополнительных данных формы в заявке'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getStockKitting: async function (id) {
      this.loading = true
      const that = this
      const urlName = '/service/delta/stock/kitting/request/get/' + id
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          const model = response.data.result
          model.kittingTime = manba(model.kittingTime).format('DD-MM-YYYY HH:mm')
          if (model.brigade && model.brigade.id) {
            this.$nextTick(() => {
              this.getBrigadeStocks(model.brigade.id).then(function (arr) {
                that.consistBrigadeStocks = arr
              })
            })
          }
          model.tools.forEach(t => {
            t.amount = t.amount != null ? parseFloat(t.amount).toFixed(3) : null
            t.amountFree = t.amountFree != null ? parseFloat(t.amountFree) : null
            t.amountStock = t.amountStock != null ? parseFloat(t.amountStock) : null
            t.amountIssued = t.amountIssued != null ? parseFloat(t.amountIssued) : null
            t.tool.value = t.tool.id
            t.tool.label = t.tool.name
            t.toolName = t.tool.name
            t.stockName = t.stock ? t.stock.stockName : '-'
            t.stock = transformStock(t.stock)
          })
          model.project = model.stock && model.stock.project || null
          model.gosNumber = model.stock && model.stock.gosNumber || null // model.vehicle && model.vehicle.name || null
          model.stock = transformStock(model.stock)
          model.stockType = model.stock ? model.stock.type : model.stockType
          this.requestComment1C = model.comment
          if (this.requestComment1C && !['SK4', 'SK5'].includes(model.stateData.state)) {
            this.requestComment1C.notUploaded = true
          }
          if (['SK1', 'SK2', 'SK3'].includes(model.stateData.state) && !this.newRecord) {
            this.validKittingTime = this.testKittingTime(response.data.result.kittingTime)
          }
          if (model.stateHistory) {
            model.stateHistory.sort((a, b) => {
              return b.time - a.time
            })
          }
          model.serviceObject = model.serviceObject || null

          const applicant = model.applicant || null
          model.organization = applicant && applicant.organization || null

          return model

          function transformStock (stock) {
            if (stock) {
              const stockTransformed = {
                id: stock.stockId,
                key: stock.stockKey,
                name: stock.stockName,
                type: stock.stockType
              }
              if (stock.detailedDebits != null) {
                stockTransformed.detailedDebits = stock.detailedDebits
                stockTransformed.stockSources = stock.stockSources
                stockTransformed.ignoreLimits = !!stock.ignoreLimits
              }
              return stockTransformed
            }
            return null
          }
        },
        onFailure: (response) => {
          const errorMessage = 'Ошибка загрузки заявки мобильного склада'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getEmptyStockKitting: function () {
      const user = this.user

      let applicant = null
      let organization = null
      let brigade = null
      if (user.employee) {
        const employee = user.employee
        applicant = { // if (this.isApplicant) как раньше?
          id: employee.id,
          name: employee.name
        }

        if (this.isMobileDevice && employee.brigadeId) {
          brigade = {
            id: employee.brigadeId,
            name: employee.brigadeName
          }
        }

        if (employee.organization) {
          organization = {
            id: employee.organization.id,
            name: employee.organization.name
          }
        }
      }

      return {
        tools: [],
        kittingShift: null,
        kittingTime: manba(new Date().getTime()).add(10, manba.MINUTE).format('DD-MM-YYYY HH:mm'),
        brigade: brigade,
        sourceBrigade: null,
        stockType: null,
        stock: null,
        vehicle: null,
        stateData: { state: 'SK0', stateAlias: 'Не создана' },
        gosNumber: null,
        serviceObject: null,
        applicant: applicant,
        organization: organization,
        project: null,
        comment: null,
        comments: null,
        number: null,
        stateHistory: null,
        actionsAccess: {}
      }
    },
    onCreateTools: function () {
      const old = this.model.tools
      this.modelTool = null
      this.$refs.modalStockKittingToolsForm.oldStock = (old && old.length) ? old[old.length - 1].stock : null
      this.$refs.modalStockKittingToolsForm.sourceBrigade = this.model.sourceBrigade
      this.$refs.modalStockKittingToolsForm.onOpen(true)
    },
    onOpenRecordTool: function (tool) {
      this.modelTool = tool
      this.$refs.modalStockKittingToolsForm.sourceBrigade = this.model.sourceBrigade
      setTimeout(() => {
        this.$refs.modalStockKittingToolsForm.onOpen(false)
      }, 500)
    },
    onRemoveRecordTool: function (id) {
      setTimeout(() => {
        this.model.tools = this.model.tools.filter(function (element) {
          return element.tool.id !== id
        })
      }, 500)
    },
    onSetTool: function (object) {
      if (object.newRecord) {
        this.model.tools.push(object.model)
      } else {
        if (!this.modelTool) {
          this.modelTool = object.model
          /* const modelToolsFound = this.model.tools.find((item) => {
            return item.tool.key == object.model.tool.key && item.tool.id == object.model.tool.id
          }) */
          const modelToolsWithoutFound = this.model.tools.filter((item) => {
            return item.tool.key !== object.model.tool.key && item.tool.id !== object.model.tool.id
          })
          this.model.tools = [...new Set([...modelToolsWithoutFound, ...[object.model]])]
        } else {
          Object.assign(this.modelTool, object.model)
        }
      }
    },
    compliteFormData: function () {
      const tools = []
      if (this.model.tools && this.model.tools.length) {
        this.model.tools.forEach(element => {
          tools.push({
            tool: {
              id: element.tool.id,
              key: element.tool.key,
              type: element.tool.type,
              name: element.tool.name,
              unit: element.tool.unit
            },
            stock: element.stock
              ? {
                stockId: element.stock.id ? element.stock.id : element.stock.stockId,
                stockKey: element.stock.key ? element.stock.key : element.stock.stockKey,
                stockName: element.stock.name ? element.stock.name : element.stock.stockName,
                stockType: element.stock.type ? element.stock.type : element.stock.stockType
              } : null,
            amount: parseFloat(element.amount),
            amountStock: element.amountStock,
            amountFree: element.amountFree,
            amountIssued: element.amountIssued,
            reserve: element.reserve
          })
        })
      }
      // console.log(tools)
      const body = {
        tools: tools,
        kittingShift: this.model.kittingShift,
        kittingTime: this.parseDate(this.model.kittingTime).getTime(),
        brigade: this.model.brigade,
        organization: this.model.organization,
        stockType: this.model.stockType,
        stock: this.model.stock ? {
          stockId: this.model.stock.id,
          stockName: this.model.stock.name,
          stockKey: this.model.stock.stockKey,
          stockType: this.model.stock.stockType
        } : null,
        vehicle: this.model.vehicle,
        applicant: this.model.applicant,
        comments: null,
        comment: this.requestComment1C
      }

      body.serviceObject = this.manager.isDogovorWithDetailedDebits && this.model.serviceObject && this.model.serviceObject.id || null

      if (this.isTransfer) {
        body.sourceBrigade = this.model.sourceBrigade
        body.isTransfer = true
      }
      if (this.model.stateData.state == 'SK2') {
        body.checkReprocess = true
      }
      const bodyFormData = new FormData()
      bodyFormData.set('props', JSON.stringify(body))
      if (!this.newRecord) {
        bodyFormData.set('objectId', this.objectId)
      }
      return bodyFormData
    },
    onSave: function () {
      this.loading = true

      if (!this.testCurrentKittingTime()) {
        this.loading = false
        return
      }

      const bodyFormData = this.compliteFormData()
      let urlName = '/service/delta/stockkittingrequest/SK' + (this.newRecord ? '1' : '2')
      if (this.model.stateData.state == 'SK2') {
        urlName = '/service/delta/stockkittingrequest/updatestate'
      }

      return axiosPost({
        url: urlName,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.objectId = response.data.result.id
          this.$q.notify({
            type: 'positive',
            message: this.newRecord ? 'Заявка создана' : 'Заявка сохранена',
            progress: true,
            timeout: 3000
          })

          this.formKitting = false
          this.onOpen(this.objectId)
          this.$emit('update-list')
          EventBus.$emit(this.updateEvent, {})

          return Promise.resolve(this.recordId)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка сохранения заявки (Exception)',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    setApplicant: function (val) {
      if (val != null) {
        this.model.applicant = val
        if (val.organization && this.model.organization && this.model.organization.id !== val.organization.id || !this.model.organization) {
          this.setOrganization(val.organization)
        }
      } else {
        this.model.applicant = null
      }
    },
    getApplicants: function () {
      const urlParams = new URLSearchParams()
      if (this.model.organization) {
        urlParams.set('organization', this.model.organization.id)
      }

      return axiosGet({
        url: '/service/delta/stock/kitting/request/searchApplicants?' + urlParams.toString(),
        onSuccess: (response) => {
          return response.data.result
        },
        onFailure: (response) => {
          const errorMessage = 'Ошибка загрузки списка заявителей'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        }
      })
    },
    onOrganizationInput: function (value) {
      this.setOrganization(value)

      if (value) {
        const applicant = this.model.applicant
        if (applicant && applicant.organization && applicant.organization.id != value.id) {
          // Организация сотрудника не соответсвует установленной -> сбрасываем заявителя
          this.model.applicant = null
        }
      } else {
        // При сбросе организации сбрасываем и заявителя
        this.model.applicant = null
      }

      // При сбросе/изменении поля «Организация» сбрасываются поля «Контракт», «Тип склада», «Склад».
      this.model.project = null
      this.model.stockType = null
      this.model.stock = null
    },
    setOrganization: function (value) {
      if (value) {
        if (!this.model.organization || this.model.organization.id !== value.id) {
          this.model.organization = {
            id: value.id,
            name: value.name,
            key: value.key
          }
        }
      } else {
        this.model.organization = null
      }
    },
    getOrganizations: function () {
      const urlParams = new URLSearchParams()
      if (this.model.stock) {
        urlParams.set('stock', this.model.stock.id)
      }
      if (this.model.project) {
        urlParams.set('project', this.model.project.id)
      }

      return axiosGet({
        url: '/service/delta/stock/kitting/request/searchOrganizations?' + urlParams.toString(),
        onSuccess: (response) => {
          return response.data.result
        },
        onFailure: 'Ошибка получения списка организаций'
      })
    },
    getProjects: function (text) {
      const urlParams = new URLSearchParams()
      if (text) {
        urlParams.set('name', text)
      }
      if (this.model.organization) {
        urlParams.set('organization', this.model.organization.id)
      }
      if (this.model.stock) {
        urlParams.set('stock', this.model.stock.id)
      }
      if (this.model.stockType) {
        urlParams.set('stockType', this.model.stockType)
      }

      return axiosGet({
        url: '/service/delta/stock/kitting/request/searchProjects?' + urlParams.toString(),
        onSuccess: (response) => {
          const projects = response.data.result
          projects.forEach(project => {
            if (project.defaultStock) {
              project.defaultStock = this.parseStockServiceObject(project.defaultStock)
            }
          })
          return projects
        },
        onFailure: (response) => {
          const errorMessage = 'Ошибка загрузки списка контрактов'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        }
      })
    },
    onProjectInput: function (value) {
      this.model.stockType = null
      this.model.stock = null

      if (value) {
        if (!this.model.project || this.model.project.id !== value.id) {
          this.model.project = value

          if (value.defaultStock) {
            this.setStock(value.defaultStock, true)
          } else {
            this.model.stockType = 'dogovor'
          }

          // Сначала заполняется Организация, потом Контракт
          // if (value.defaultOrganization) {
          //   this.onOrganizationInput(value.defaultOrganization)
          // }
        }
      } else {
        this.model.project = null
      }
    },
    onAddComment1C: function () {
      this.askComment(comment => {
        this.requestComment1C = comment
      }, 'Добавление комментария в 1С')
    },
    onEditComment1C: function (commentData) {
      this.askComment(comment => {
        this.requestComment1C = comment
      }, 'Редактирование комментария в 1С', commentData.comment)
    },
    askComment: function (callback, title, commentInitial) {
      this.$d_ask(data => {
        const user = this.$store.getters.getUser
        // eslint-disable-next-line standard/no-callback-literal
        callback({
          comment: data.comment,
          fio: user.name ? user.name : null,
          notUploaded: true,
          time: new Date().getTime(),
          user: user.login
        })
      }, title, {
        comment: { type: 'text', label: 'Комментарий', value: commentInitial, required: true }
      })
    },
    cancelField: function (refKey) {
      const input = this.$refs[refKey].$refs.target
      if (input) {
        input.blur()
      }
    },
    onCancelOrReject: function (stateNumber) {
      this.$d_ask(data => {
        this.reasonCansel = data.reason

        const bodyFormData = new FormData()
        bodyFormData.set('objectId', this.objectId)
        bodyFormData.set('props', JSON.stringify(data))
        this.changePBState(stateNumber, bodyFormData, stateNumber == 7 ? 'Заявка аннулирована' : 'Заявка отправлена в доработку')
      }, stateNumber == 7 ? 'Аннулирование заявки' : 'Отправка заявки в доработку', {
        reason: { type: 'text', label: 'Причина', required: true }
      })
    },
    onReadyOrAgreed: function (stateNumber) {
      if (this.testCurrentKittingTime()) {
        this.changePBState(stateNumber, this.compliteFormData(), stateNumber == 3 ? 'Заявка готова к согласованию' : 'Заявка согласована')
      }
    },
    changePBState: function (stateNumber, bodyFormData, errMsg) {
      this.loading = true
      return axiosPost({
        url: '/service/delta/stockkittingrequest/SK' + stateNumber,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.objectId = response.data.result.id
          this.$q.notify({
            type: 'positive',
            message: errMsg || 'Статус успешно изменен',
            progress: true,
            timeout: 3000
          })
          this.formKitting = false
          this.$emit('update-list')
          EventBus.$emit(this.updateEvent, {})
          return Promise.resolve(this.recordId)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка изменения статуса',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(response.message)
        }
      })
        .finally(() => {
          this.loading = false
          /* this.formKitting = false
          this.onOpen(this.objectId)
          this.$emit('update-list')
          EventBus.$emit(this.updateEvent, {}) */
        })
    },
    getBrigadeStocks: function (id) {
      return axiosGet({
        url: '/service/delta/brigade/' + id + '/stocks',
        onSuccess: (response) => {
          const stockTypesKeys = new Set(this.stockTypes.map(type => type.key))
          const stockTools = this.getStocksFromTools()
          return response.data.result
            .filter(element => {
              if (stockTools.includes(element.id)) {
                this.$q.notify({
                  type: 'negative',
                  message: 'Нельзя выбрать склад-приемник ' +
                  element.name + (element.gosNomer ? ('(' + element.gosNomer + ')') : '') +
                  ' совпадающий со складом выбранных материалов!',
                  progress: true,
                  timeout: 10000
                })
              }
              return stockTypesKeys.has(element.type) && (stockTools ? (!stockTools.includes(element.id)) : true)
            })
            .map(element => {
              return {
                id: element.id,
                name: element.name + (element.gosNomer ? (' ' + element.gosNomer) : ''),
                key: element.key,
                type: element.type,
                typeName: this.getStockTypeName(element.type),
                gosNumber: element.gosNomer,
                project: element.project,
                detailedDebits: element.detailedDebits,
                nameShort: element.name
              }
            }).sort((a, b) => (a.type > b.type) ? 1 : -1)
        },
        onFailure: (response) => {
          const errorMessage = 'Ошибка загрузки списка доступных складов бригады'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        }
      })
    },
    getBrigadeConfiguration: function (brigade) {
      const urlParams = new URLSearchParams()
      urlParams.set('brigade', brigade.id)

      if (brigade.workDate) {
        urlParams.set('workDate', brigade.workDate)
      } else if (this.model.kittingTime) {
        const kittingDate = this.parseDate(this.model.kittingTime).getTime()
        urlParams.set('workDate', kittingDate)
      }

      if (brigade.workShift) {
        urlParams.set('workShift', brigade.workShift)
      } else if (this.model.kittingShift) {
        urlParams.set('workShift', this.model.kittingShift)
      }

      return axiosGet({
        url: '/service/delta/stock/kitting/request/getBrigadeConfiguration?' + urlParams.toString(),
        onSuccess: (response) => response.data.result,
        onFailure: (response) => {
          const errorMessage = 'Ошибка загрузки данных бригады'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        }
      })
    },
    updateAllowedToolsIds: async function () {
      const stockId = this.manager.targetStockId
      if (this.manager.isDogovor && stockId) {
        const allowedToolsIds = await this.loadAllowedToolsIds(stockId)
        this.manager.allowedToolsIds = allowedToolsIds || null
      } else {
        this.manager.allowedToolsIds = null
      }
    },
    loadAllowedToolsIds: function (stockId) {
      return axiosGet({
        url: '/service/delta/stock/kitting/request/validTools?stockId=' + stockId,
        onSuccess: (response) => response.data.result,
        onFailure: (response) => {
          const errorMessage = 'Ошибка загрузки списка разрешенных материалов'
          this.$q.notify({
            type: 'negative',
            message: response.message || errorMessage,
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error(errorMessage))
        }
      })
    },
    onSetServiceObject: function (serviceObject) {
      this.model.serviceObject = serviceObject
    },
    close: function () {
      this.$router.push(this.isTransfer ? '/stockBlock/stockKittingTransfer' : '/stockBlock/stockKitting').catch(() => {})
    },
    getConsistBrigade: function (employees) {
      if (!employees) {
        return null
      }
      return employees.map(function (e) {
        return { name: formatInitials(e.fio), brigadier: e.brigadier }
      })
    }
  }
}

